import fb, { getDocsFromCollection } from '@/firebase'
import store from '@/store'
import router from '@/router'

const state = {
  program: null,
  programs: null,
  allPrograms: null,
  schoolPrograms: null,
  schoolTopPrograms: null
}

const getters = {
  program: state => state.program,
  programs: state => state.programs,
  allPrograms: state => state.allPrograms,
  schoolPrograms: state => state.schoolPrograms,
  schoolTopPrograms: state => state.schoolTopPrograms
}

const mutations = {
  setPrograms: (state, payload) => {
    state.programs = payload
  },
  setAllPrograms: (state, payload) => {
    state.allPrograms = payload
  },
  setProgram: (state, payload) => {
    state.program = payload
  },
  setSchoolPrograms: (state, payload) => {
    state.schoolPrograms = payload
  },
  setSchoolTopPrograms: (state, payload) => {
    state.schoolTopPrograms = payload
  }
}

const actions = {
  getPrograms: ({commit}) => {
    store.dispatch('setLoaderStatus', true)
    fb.getPrograms()
      .then((fetched) => {
        commit('setPrograms', getDocsFromCollection(fetched))
        store.dispatch('setLoaderStatus', false)
      })
  },
  getAllPrograms: ({commit}) => {
    store.dispatch('setLoaderStatus', true)
    fb.getAllPrograms()
      .then((fetched) => {
        commit('setAllPrograms', getDocsFromCollection(fetched))
        store.dispatch('setLoaderStatus', false)
      })
  },
  getProgram: ({commit}, id) => {
    store.dispatch('setLoaderStatus', true)
    fb.getProgram(id)
      .then((fetched) => {
        let docData = fetched.data()
        const data = {...docData, ...{id: fetched.id, ref: fetched.ref}}
        commit('setProgram', data)
        store.dispatch('setLoaderStatus', false)
      })
  },
  addProgram: ({commit}, payload) => {
    store.dispatch('setLoaderStatus', true)
    fb.addProgram(payload)
      .then((response) => {
        store.dispatch('setLoaderStatus', false)
        store.dispatch('setSuccessMessage', 'Program details saved successfully')
        store.dispatch('getPrograms')
      })
  },
  updateProgram: ({commit}, params) => {
    store.dispatch('setLoaderStatus', true)
    fb.updateProgram(params.id, params.payload)
      .then((response) => {
        store.dispatch('setLoaderStatus', false)
        store.dispatch('getProgram', params.id)
        store.dispatch('setSuccessMessage', 'Program details updated successfully')
        store.dispatch('getPrograms')
        store.dispatch('getAllPrograms')
      })
  },
  getSchoolTopPrograms: ({commit}, schoolRef) => {
    store.dispatch('setLoaderStatus', true)
    fb.getSchoolTopPrograms(schoolRef)
      .then((fetched) => {
        commit('setSchoolTopPrograms', getDocsFromCollection(fetched))
        store.dispatch('setLoaderStatus', false)
      })
  },
  getSchoolTopProgramsFiltered: ({commit}, payload) => {
    store.dispatch('setLoaderStatus', true)
    fb.getSchoolTopPrograms(payload.schoolRef, payload.filters)
      .then((fetched) => {
        commit('setSchoolTopPrograms', getDocsFromCollection(fetched))
        store.dispatch('setLoaderStatus', false)
      })
  },
  getSchoolPrograms: ({commit}, schoolRef) => {
    store.dispatch('setLoaderStatus', true)
    fb.getSchoolPrograms(schoolRef)
      .then((fetched) => {
        commit('setSchoolPrograms', getDocsFromCollection(fetched))
        store.dispatch('setLoaderStatus', false)
      })
  },
  getSchoolProgramsFiltered: ({commit}, payload) => {
    store.dispatch('setLoaderStatus', true)
    fb.getSchoolPrograms(payload.schoolRef, payload.filters)
      .then((fetched) => {
        commit('setSchoolPrograms', getDocsFromCollection(fetched))
        store.dispatch('setLoaderStatus', false)
      })
  },
  getSchoolProgramsBySchoolName: ({commit}, schoolName) => {
    store.dispatch('setLoaderStatus', true)
    fb.getSchoolProgramsBySchoolName(schoolName)
      .then((fetched) => {
        commit('setSchoolPrograms', getDocsFromCollection(fetched))
        store.dispatch('setLoaderStatus', false)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/programs.js